import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from './Dialog';
import CardButton from './CardButton';
import { BuildRounded, SwapHorizontalCircleRounded } from '@material-ui/icons';
import PopUp from './PopUp';

const SendToTransfer = (props) => {

    return (
        <PopUp 
            disableBackdropClick
            block={true}
            close={props.close}
            title={`Envoyer vers`}
            appbar
            maxWidth="xs"
            fullScreen={false}

        >
            <CardButton
                title="Réappro"
                action={props.reappro}
                icon={<SwapHorizontalCircleRounded color="primary"/>}
            />
            <CardButton
                title="Installation"
                icon={<BuildRounded color="primary"/>}
                // action={}
            />
            
            
        </PopUp>   
    );
};

export default SendToTransfer;
